(function (Podcast, $) {
  
  const $dom = {};

  const cacheDom = () => {
    $dom.playToggle = $('.toggle');
    $dom.player = $('#podcast-player');
    $dom.playerAudio = $('#podcast-player').get(0);
    $dom.ranges = $('.player__slider');
  }

  const togglePlay = () => {
    const method = $dom.playerAudio.paused ? 'play' : 'pause'
    $dom.playerAudio[method]();
    updateButton();
  }

  const updateButton = () => {
    const icon = $dom.playerAudio.paused ?  '►' : '❚❚';
    $dom.playToggle.text(icon);
  }

  const handleRangeUpdates = (event) =>{
    $dom.playerAudio.currentTime = event.currentTarget.value;
  }

  const secondsTimeSpanToHMS = (s) => {
    const h = Math.floor(s/3600); //Get whole hours
    s -= h*3600;
    const m = Math.floor(s/60); //Get remaining minutes
    s -= m*60;
    return h+":"+(m < 10 ? '0'+m : m)+":"+(s < 10 ? '0'+s : s); //zero padding on minutes and seconds
  }

  const handleProgress = () => {
    const percent = ($dom.playerAudio.currentTime / $dom.playerAudio.duration) * 100;
    const time = secondsTimeSpanToHMS(Math.floor($dom.playerAudio.currentTime));
    $dom.ranges.val($dom.playerAudio.currentTime);
    $('.updatedTime').text(time);
  }

  const initialLoad = () => {
    const duration = secondsTimeSpanToHMS(Math.floor($dom.playerAudio.duration));
    const time = secondsTimeSpanToHMS(Math.floor($dom.playerAudio.currentTime));
    $('.audio-length').text(duration);
    $('.updatedTime').text(time);
    $dom.ranges.attr('max', Math.floor($dom.playerAudio.duration));
  }

  const bindUIActions = function () {
    $dom.playToggle.on('click', togglePlay);
    $dom.ranges.on('change', handleRangeUpdates);
    $dom.player.on('timeupdate', handleProgress);
    $dom.player.on('loadedmetadata', initialLoad);
    $dom.player.on('ended', updateButton);
  };

  Podcast.init = function () {
    cacheDom();
    if(typeof $dom.playerAudio !== 'undefined') {
      initialLoad();
      bindUIActions();
    }
  };

}(window.Podcast = window.Podcast || {}, jQuery));
